<script>
    import { Row, Col, Card, CardBody } from 'sveltestrap'
    import { InputText, InputCheckbox } from '@fno/component2/form.js'
    import { createEventDispatcher } from 'svelte'
    import { get } from 'dot-prop'

    export let context
    export let formKey
    export let index
    export let disabled

    let hasIssue = false

    $: {
        const alerts = get(context, 'alerts') || []
        const errors = get(context, `errors.${formKey}.${index}`)

        hasIssue = (get(context, 'alerts') || []).find((alert) => Number(alert.index) == index) || errors ? true : false
    }
</script>

<style>
    :global(.user-info-error) {
        border: 1px solid red;
    }
</style>

<Card>
    <CardBody class={hasIssue ? 'user-info-error' : ''}>
        <Row>
            <Col>
                <InputText
                    label="First Name"
                    required
                    {context}
                    {formKey}
                    {index}
                    keypath="attributes.firstname"
                    bind:value={context.form[formKey][index].attributes.firstname}
                    on:change
                    {disabled}
                />
            </Col>
            <Col>
                <InputText
                    label="Last Name"
                    required
                    {context}
                    {formKey}
                    {index}
                    keypath="attributes.lastname"
                    bind:value={context.form[formKey][index].attributes.lastname}
                    on:change
                    {disabled}
                />
            </Col>
        </Row>
        <Row>
            <Col>
                <InputText
                    label="Email"
                    required
                    {context}
                    {formKey}
                    {index}
                    keypath="attributes.email"
                    bind:value={context.form[formKey][index].attributes.email}
                    on:change
                    {disabled}
                />
            </Col>
            <Col>
                <InputText
                    label="Phone Number"
                    {context}
                    {formKey}
                    {index}
                    keypath="attributes.phoneNumber"
                    bind:value={context.form[formKey][index].attributes.phoneNumber}
                    on:change
                    {disabled}
                />
            </Col>
        </Row>
        <Row>
            <Col>
                <InputCheckbox
                    label="Rewards Permissions"
                    {context}
                    {formKey}
                    {index}
                    keypath="attributes.$rewards-manager"
                    bind:value={context.form[formKey][index].attributes.$rewardsManager}
                    on:change
                    {disabled}
                />

                <InputCheckbox
                    label="Notification Permissions"
                    {context}
                    {formKey}
                    {index}
                    keypath="attributes.$notification-manager"
                    bind:value={context.form[formKey][index].attributes.$notificationManager}
                    on:change
                    {disabled}
                />
            </Col>
        </Row>
    </CardBody>
</Card>
